import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import { MAP_TOOLS } from '../../../lib/constants';
import styles from './MeasurementWidget.module.scss';
import actions from './actions';
import MeasureIcon from '../../../assets/svg/MeasureIcon';
import Measurement from '@arcgis/core/widgets/Measurement';

function MeasurementWidget(props) {
  const [measureWidget, setMeasure] = useState(null);

  useEffect(() => {
    /*
      #NOTE: Keeping this commented out in case there are now side-effects (haven't found any yet though)
      -- KD - July 22, 2020
    */
    // if (props.view.ui.find('measure') != null ) {
    //   return;
    // }

    const measure = new Measurement({
      id: 'measure',
      view: props.view,
      linearUnit: 'yards',
    });

    props.setMeasurementWidgetRef(measure);

    setMeasure(measure);
    props.view.ui.add(measure, {
      position: 'manual',
    });

    return () => {
      props.view.ui.remove(measureWidget);
    };
  }, [props.view]);

  if (!props.isMapReady) return null;

  return (
    // <div
    //   className={[styles.container, 'esri-component esri-widget'].join(' ')}
    //   style={{ visibility: props.isUpdatingLocation ? 'hidden' : 'visible' }}
    // >
    /*
      #TODO: Remove Esri theme styles
      -- TJC - June 17, 2021
    */
      <button
        className={[
          'esri-widget--button',
          'esri-interactive',
          // 'esri-icon-measure-line',
          'esri-widget__button--selected',
          styles.measureButton,
          props.activeTool === MAP_TOOLS.Measure ? styles.selected : '',
        ].join(' ')}
        onClick={
          props.activeTool === MAP_TOOLS.Measure
            ? props.clearMeasurements
            : props.enableLineMeasurement
        }
        title="Measure distance"
      >
        <MeasureIcon color="#ffffff" width={20} height={20} />
      </button>
    // </div>
  );
}

MeasurementWidget.propTypes = {
  view: PropTypes.any,
  map: PropTypes.any,
  isMapReady: PropTypes.bool,
  activeTool: PropTypes.string,
  measureWidgetRef: PropTypes.any,
  isUpdatingLocation: PropTypes.bool,
  //actions
  enableLineMeasurement: PropTypes.func,
  setMeasurementWidgetRef: PropTypes.func,
  clearMeasurements: PropTypes.func,
};

export default connect((model) => {
  return {
    isMapReady: model.map.isMapReady,
    activeTool: model.map.activeTool,
    measureWidgetRef: model.map.widgetRefs.measurement,
    isUpdatingLocation: model.map.isUpdatingLocation,
  };
}, actions)(MeasurementWidget);
